export default {"src":"/_next/static/media/greenCircle.73b06f59.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};